import { NgModule } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: '**',
    component: HomeComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, enableTracing: false } ) ],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor(
    public route: Router,
  ) {

  }

}
